
import { Component, Vue, } from 'vue-property-decorator';
import { Store, } from '~/apps/pay-bill/store';
import HeaderText from '~/components/header-text/header-text.vue';
import LandingLink from '~/components/landing-link/landing-link.vue';
import Checklist from '~/components/self-serve/checklist/checklist.vue';
import LandingSection from '~/components/self-serve/landing-section/landing-section.vue';
import { CHECKLIST_ITEMS, } from '~/utils/self-serve-checklist-items';

const ChecklistItems = [
	CHECKLIST_ITEMS.customerNumber,
	CHECKLIST_ITEMS.paymentReference,
	CHECKLIST_ITEMS.lastNameOnBill,
	CHECKLIST_ITEMS.emailAddress,
	CHECKLIST_ITEMS.bankDetails,
];

@Component({
	components: {
		HeaderText,
		LandingLink,
		LandingSection,
		Checklist,
	},
})
export default class PayBillLandingPage extends Vue {
	mounted() {
		sessionStorage.clear();
		Store.commit.setStep(null);
		Store.commit.reset();
	}

	get troublePayingBillLocation() {
		return Store.getters.getGlobalConfigValue('TroublePayingBillLocation');
	}

	checklistItems = ChecklistItems;
}
